// extracted by mini-css-extract-plugin
module.exports = {"comment-box":"comment-box___1J3wi","add-note":"add-note___1jTXe","textarea-wrapper":"textarea-wrapper___3ExVR","display-text":"display-text___1-fn_"};